import React from 'react'

import {
  FieldSpec,
  LinkedField,
  PaginatedTable,
  RelatedLinkedField,
  SkuUnitField,
  ValueField,
} from 'src/components/Table'
import {ListTableProps} from './types'

const fieldOptions: {[key: string]: FieldSpec} = {
  sku: {id: 'sku', label: 'SKU', renderer: LinkedField(ValueField)},
  product: {id: 'product', label: 'Product', ordering: 'product__name', renderer: RelatedLinkedField(ValueField, 'name')},
  numAvailable: {id: 'numAvailable', label: 'Number of Units Available', ordering: 'num_available', renderer: SkuUnitField},
  numReserved: {id: 'numReserved', label: 'Number of Units in Orders', ordering: 'num_reserved', renderer: SkuUnitField},
  numAwaitingShipment: {id: 'numAwaitingShipment', label: 'Number of Units Awaiting Shipment', ordering: 'num_awaiting_shipment', renderer: SkuUnitField},
  numUnitsInAudit: {id: 'numUnitsInAudit', label: 'Number of Units In Audit', ordering: 'num_units_in_audit', renderer: SkuUnitField},
}

export const AuditResultSkuListTable = (props: ListTableProps) => {
  const {paginator, fields, extraActions, exportConfig} = props

  return (
    <>
      <PaginatedTable
        title="SKUs"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={extraActions}
        exportConfig={exportConfig}
      />
    </>
  )
}
